module.exports = __webpack_public_path__ + "img/DOT.abae6ed4.png";